<template>
  <ul class="el-menu">
    <li
      class="el-menu-item"
      style="padding-left: 20px;">
      <i :class="indicator.style"></i>
      <span>
        {{ indicator.text }}
      </span>
    </li>
  </ul>
</template>

<script>
import networkActivity from '@/store/modules/networkActivity';

const STATUS = networkActivity.state.STATUS;
const copy = {
  [STATUS.ERROR]: {
    style: 'el-icon-close',
    text: 'Error saving changes',
  },
  [STATUS.SAVED]: {
    style: 'el-icon-check',
    text: 'All changes saved',
  },
  [STATUS.SAVING]: {
    style: 'el-icon-loading',
    text: 'Saving...',
  },
};

export default {
  computed: {
    status() {
      return this.$store.state.networkActivity.status;
    },
    indicator() {
      return copy[this.status] || {};
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Utilities/SaveIndicator.vue